<template>
  <div>
    <Card>
      <div class="search-con search-con-top">
        <Form :model="form" :label-width="80" inline>
          <FormItem label="账户">
            <Input v-model="form.accountNo"></Input>
          </FormItem>
          <FormItem label="开始月份">
            <DatePicker v-model="form.map.startDay" format="yyyy-MM"></DatePicker>
          </FormItem>
          <FormItem label="结束月份">
            <DatePicker v-model="form.map.endDay" format="yyyy-MM" :start-date="form.map.startDay"></DatePicker>
          </FormItem>
        </Form>
        <div class="toolbar">
          <Button type="primary" icon="ios-recording" @click="handleExport">导出</Button>
          <Button type="primary" icon="ios-recording" @click="handleExportOne">导出月度统计账单</Button>
          <Button @click="handleSearch" icon="md-search" class="search-btn" type="primary">搜索</Button>
        </div>
      </div>
      <Tables ref="tables" v-model="tableData" :columns="columns" @on-search="handleSearch"
              @on-update="handleUpdate" @on-detail="handleDetail" @on-selection-change="selectionChange"/>
    </Card>
  </div>
</template>

<script>

import { formatDate } from '@/libs/dateutil'

export default {
  name: 'stat-month-list',
  components: {},
  data () {
    return {
      columns: [
        { title: '账户', key: 'accountNo' },
        { title: '机构', key: 'tenantName' },
        { title: '统计月份', key: 'day' },
        { title: '消费金额', key: 'outMoney' },
        { title: '余额', key: 'balance' },
        { title: '消费次数', key: 'countData' },
        { title: '创建时间', key: 'crtTime' }
      ],
      tableData: {
        rows: [],
        total: 0
      },
      form: {
        type: 2,
        map: {}
      },
      selectedData: [],
      infoIsShow: false
    }
  },
  methods: {
    handleExport () {
      this.form.startDay = formatDate(this.form.map.startDay, 'yyyy-MM')
      this.form.endDay = formatDate(this.form.map.endDay, 'yyyy-MM')
      this.DL('api/trade/accountreconciliation/exportExcel?', this.form)
    },
    handleExportOne () {
      if (!this.form.map.startDay) {
        this.$Message.error('开始时间必填')
        return
      }
      if (!this.form.accountNo) {
        this.$Message.error('账户必填')
        return
      }
      this.form.startDay = formatDate(this.form.map.startDay, 'yyyy-MM')
      this.DL('api/trade/accountflow/exportExcel?', this.form)
    },
    selectionChange (selection) {
      this.selectedData = selection
    },
    handleSearch (page, pageSize) {
      if (isNaN(page)) {
        page = 1
      }
      let param = {
        page: page,
        pageSize: pageSize,
        model: this.form,
        map: {
          startDay: formatDate(this.form.map.startDay, 'yyyy-MM'),
          endDay: formatDate(this.form.map.endDay, 'yyyy-MM')
        }
      }
      this.L('trade/accountreconciliation', param).then(data => {
        this.tableData = data
      })
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>
